import type { BuiltinTokenMap } from '@visactor/vchart';

export const token: BuiltinTokenMap = {
  fontFamily:
    // eslint-disable-next-line max-len
    'PingFang SC,Helvetica Neue,Microsoft Yahei,system-ui,-apple-system,segoe ui,Roboto,Helvetica,Arial,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol',
  fontSize: 12,

  l1FontSize: 30,
  l1LineHeight: '150%',

  l2FontSize: 18,
  l2LineHeight: '140%',

  l3FontSize: 14,
  l3LineHeight: '150%',

  l4FontSize: 12,
  l4LineHeight: '150%',

  l5FontSize: 10,
  l5LineHeight: '130%',

  l6FontSize: 8,
  l6LineHeight: '120%'
};
